/* @flow */
// typecheck: ignore file
import React from 'react';
import Dialog from 'components/Dialog.jsx';
import Activity from 'entities/Activity';
import BoxBody from 'components/BoxBody.jsx';
import ActivityTransactionsTableContainer from 'payments/containers/ActivityTransactionsTableContainer.jsx';
import ActivityDepositStarter from 'payments/components/ActivityDepositStarter.jsx';
import Button from 'components/Button.jsx';
import Money from 'payments/components/Money.jsx';

import './styles/ActivityTransactionsModal.scss';

type Props = {
  activity: Activity,
  onRequestHide?: () => any,
};

export default function ActivityTransactionsModal(props: Props) {
  const { activity, onRequestHide, ...rest } = props;
  const balance = activity.getCurrentBalance();

  return (
    <Dialog
      {...rest}
      size="xlarge"
      onRequestHide={onRequestHide}>
      <BoxBody className="ActivityTransactionsModal-body">
        <div className="ActivityTransactionsModal-header">
          <div>
            <h1>Transactions</h1>
            <h2>
              You currently have
              {' '}<Money cents={activity.getCurrentBalance()} />{' '}
              to deposit
            </h2>
          </div>
          <div>
            <ActivityDepositStarter activity={activity}>
              {({ start, loading }) =>
                <Button
                  onClick={start}
                  loading={loading}
                  disabled={!balance || balance <= 0}>
                  Deposit <Money cents={balance} />
                </Button>
              }
            </ActivityDepositStarter>
          </div>
        </div>
        <ActivityTransactionsTableContainer activity={activity} />
      </BoxBody>
    </Dialog>
  );
}



// WEBPACK FOOTER //
// ./src/payments/components/ActivityTransactionsModal.jsx